import React, { useEffect, useState } from 'react';

const VoiceWaveform = ({ isActive, height = 28, barCount = 20 }) => {
  const [bars, setBars] = useState([]);

  useEffect(() => {
    // Initialize bars with random heights
    const generateBars = () => {
      return Array.from({ length: barCount }, () => 
        Math.random() * (isActive ? 100 : 20) + (isActive ? 0 : 5)
      );
    };

    setBars(generateBars());

    if (isActive) {
      // Animate bars for active agents
      const interval = setInterval(() => {
        setBars(generateBars());
      }, 150); // Update every 150ms for smooth animation

      return () => clearInterval(interval);
    }
  }, [isActive, barCount]);

  return (
    <div className="flex items-end justify-center gap-0.5" style={{ height: `${height}px` }}>
      {bars.map((barHeight, index) => (
        <div
          key={index}
          className={`transition-all duration-150 rounded-full ${
            isActive ? 'bg-primary' : 'bg-muted-foreground/30'
          }`}
          style={{
            width: '3px',
            height: `${barHeight}%`,
            minHeight: '3px',
          }}
        />
      ))}
    </div>
  );
};

export default VoiceWaveform;

